import { isScheduleTaskCompletedForDate } from '@griply/utils';
import { useHabits, useRepeatingTasks } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';

export const useTodaysCompletedHabits = () => {
  const repeatingTasks = useRepeatingTasks();
  const habits = useHabits();
  const today = useToday();

  return useMemo(
    () =>
      [...habits, ...repeatingTasks].filter(
        (task) =>
          !task.hideOnTodo && isScheduleTaskCompletedForDate(task, today),
      ),
    [habits, repeatingTasks, today],
  );
};
